// src/flows/masterclass/ai/AIStepLayout.tsx
import { Box, Button, Typography } from '@mui/material';
import StepNavigator from '../components/StepNavigator';
import DosenButton from '../../../../ui/Buttons/DosenButton';
import EastRoundedIcon from '@mui/icons-material/EastRounded';

export function AIStepLayout({
  stepTitle,
  title,
  children,
  onBack,
  onNext,
  nextDisabled,
  nextLoading,
  isLastStep,
  nextLabel,
  steps
}: any) {
  return (
    <Box display="flex" flexDirection="column" height="100%" bgcolor="#151515">
      <Box px={6} pt={4} display="flex" justifyContent="center">
        <StepNavigator currentStep={stepTitle} steps={steps} />
      </Box>
      <Box flex={1} display="flex" justifyContent="center" p={10} overflow="hidden">
        <Box width={600} display="flex" flexDirection="column" gap={4} maxHeight="100%" overflow="auto" pr={1}>
          <Typography color="#FDFDFD" fontSize={28} fontWeight={500}>
            {title}
          </Typography>
          {children}
        </Box>
      </Box>

      <Box borderTop="1px solid #2A2A2A" p={3} display="flex" justifyContent="space-between">
        <DosenButton onClick={onBack} tone="basic">
          Previous
        </DosenButton>
        <DosenButton
          disabled={nextDisabled}
          loading={nextLoading}
          onClick={onNext}
          iconPosition="end"
        >
          {nextLabel || (isLastStep ? 'Save & Finish' : 'Next')}
          <EastRoundedIcon />
        </DosenButton>
      </Box>
    </Box>
  );
}
